function getFirstConnector(first = true) {
  return first ? '?' : '&';
}

export default function createQuestionnaireUrl(session, response, auth = undefined, callbackUrl = undefined) {
  // Put together the url of the questionnaire
  let url = `${session.baseUrl}/questionnaire/${response.uuid}`;
  let connector = '';
  let first = true;

  if (auth !== undefined) {
    connector = getFirstConnector(first);
    first = false;
    url += `${connector}auth=${auth}`;
  }

  if (callbackUrl !== undefined) {
    connector = getFirstConnector(first);
    first = false;
    url += `${connector}callback_url=${callbackUrl}`;
  }

  return url;
}

